import { render, staticRenderFns } from "./accountGroup.vue?vue&type=template&id=c57fd5d4"
import script from "./accountGroup.vue?vue&type=script&lang=ts"
export * from "./accountGroup.vue?vue&type=script&lang=ts"
import style0 from "./accountGroup.vue?vue&type=style&index=0&id=c57fd5d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports